import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { BannerDescriptionStyled } from 'blocks/Banner/Description'
import { MEDIA } from 'vars/index'
import { Banner } from '../Banner'
import { BannerContent } from '../Banner.styled'

export const BannerTemplate = styled(Banner)`
  ${MEDIA.MAX_767} {
    width: 100%;
  }

  // mobile landscape
  @media screen and (min-width: 600px) and (max-width: 639px) and (orientation: landscape) {
    aspect-ratio: 0.66;
  }

  ${BannerContent} {
    ${MEDIA.MIN_600} {
      padding: 7% 16px;
    }

    ${MEDIA.MIN_1240} {
      padding: 7% 8%;
    }

    ${MEDIA.MIN_1920} {
      padding: 7% 6%;
    }
  }

  ${BannerDescriptionStyled} {
    ${MEDIA.MAX_1239} {
      ${TextBoxSC} {
        &:nth-child(1) {
          -webkit-line-clamp: 1;
        }

        &:nth-child(2) {
          -webkit-line-clamp: 2;
        }
      }
    }

    ${MEDIA.MIN_600} {
      width: calc(40% + 100px);
    }

    @media screen and (min-width: 600px) and (max-width: 639px) and (orientation: landscape) {
      width: 100%;
    }

    ${MEDIA.MIN_1240} {
      width: 457px;
    }
  }
`
